import { useContext } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AbilityContext } from '../../../../utility/context/Can'
import { selectUser, logout } from '../../../../redux/slices/authSlice'
import { addAuditLog } from '../../../../redux/slices/auditSlice'
import { ChevronRight, LogOut } from 'react-feather'
import { SmallLogo, LightFullLogo } from '../../../../assets/logo'
import './Sidebar.scss'

const Sidebar = ({ menuData = [], menuCollapsed, setMenuCollapsed }) => {
  const navigate = useNavigate()
  const ability = useContext(AbilityContext)
  const user = useSelector(selectUser)
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(addAuditLog({ action: 'LOGOUT_INITIATED', subject: 'Auth' }))
    dispatch(logout())
  }

  const handleProfileClick = () => navigate('/profile')

  return (
    <aside className={`sidebar ${menuCollapsed ? 'sidebar--collapsed' : ''}`}>

      {/* Brand */}
      <div className="sidebar-brand">
        <NavLink to="/dashboard" className="brand-link">
          {menuCollapsed
            ? <img src={SmallLogo} alt="PB Pay" className="brand-logo-small" />
            : <img src={LightFullLogo} alt="PB Pay" className="brand-logo-full" />
          }
        </NavLink>
        <button className="sidebar-toggle" onClick={() => setMenuCollapsed(c => !c)}>
          <ChevronRight size={15} className={!menuCollapsed ? 'rotated' : ''} />
        </button>
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        <ul>
          {(() => {
            const elements = []
            let currentHeader = null
            let currentItems = []

            const flushSection = () => {
              if (currentItems.length === 0) return

              if (!menuCollapsed && currentHeader) {
                elements.push(
                  <li key={`header-${currentHeader}`} className="nav-header">
                    <span>{currentHeader}</span>
                  </li>
                )
              }

              currentItems.forEach(item => {
                elements.push(
                  <li key={item.id} className="nav-item">
                    <NavLink
                      to={item.navLink}
                      end={item.navLink === '/dashboard'}
                      className={({ isActive }) =>
                        `nav-link ${isActive ? 'active' : ''}`
                      }
                      title={menuCollapsed ? item.title : undefined}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      {!menuCollapsed && (
                        <span className="nav-title">{item.title}</span>
                      )}
                    </NavLink>
                  </li>
                )
              })

              currentItems = []
            }

            menuData.forEach(item => {
              if (item.header) {
                flushSection()
                currentHeader = item.header
                return
              }

              const allowed =
                !item.action ||
                !item.resource ||
                ability.can(item.action, item.resource)

              if (allowed) {
                currentItems.push(item)
              }
            })

            flushSection()

            return elements
          })()}
        </ul>
      </nav>
      {/* Footer */}
      <div className="sidebar-footer">
        {user && (
          <button className="sidebar-user" onClick={handleProfileClick} title="View profile">
            <div className="sidebar-avatar">{(user.name || user.email || '?')[0].toUpperCase()}</div>
            {!menuCollapsed && (
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{user.name || user.email}</span>
                <span className="sidebar-user-role">{user.role}</span>
              </div>
            )}
          </button>
        )}
        <button className="sidebar-logout" onClick={handleLogout} title="Sign out">
          <LogOut size={15} />
          {!menuCollapsed && <span>Sign out</span>}
        </button>
      </div>
    </aside>
  )
}

export default Sidebar